import React from 'react';
import PropTypes from 'prop-types';
import { PropTypeBn } from '@blockcatio/tabby-library/lib/utilities/PropTypeBn';
import { noop } from 'lodash';
import EthereumAddress from '@blockcatio/tabby-library/lib/components/EthereumAddress';
import FormattedWei from '@blockcatio/tabby-library/lib/components/FormattedWei';

const WalletInfo = ({
  address, balance, catBalance, onWalletChange, showChangeWallet,
}) => {
  if (address) {
    return (
      <div className="wallet-info">
        <div className="item">
          <strong>Address</strong>
          <EthereumAddress address={address} showImage />
        </div>
        {showChangeWallet && (
          <button className="btn" name="changeWallet" type="button" onClick={onWalletChange}>
            Change Wallet
          </button>
        )}
        <ul className="balances">
          <strong>Balance</strong>
          <li>
            <FormattedWei wei={balance} suffix="ETH" />
          </li>
          <li>
            <FormattedWei wei={catBalance} suffix="CAT" />
          </li>
        </ul>
      </div>
    );
  }
  return null;
};

WalletInfo.displayName = 'WalletInfo';

WalletInfo.defaultProps = {
  address: '',
  balance: null,
  catBalance: null,
  onWalletChange: noop,
  showChangeWallet: false,
};

WalletInfo.propTypes = {
  address: PropTypes.string,
  balance: PropTypeBn,
  catBalance: PropTypeBn,
  onWalletChange: PropTypes.func,
  showChangeWallet: PropTypes.bool,
};

export default WalletInfo;



// WEBPACK FOOTER //
// ./src/components/WalletInfo.js